var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTermsConditions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 6.41666H14.6666",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33325 10.0833H10.9999",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 19.7083V19.25C11.9167 16.6573 11.9167 15.361 12.7222 14.5555C13.5277 13.75 14.824 13.75 17.4167 13.75H17.8751M18.3334 12.2312V9.16668C18.3334 5.70971 18.3334 3.98123 17.2594 2.90728C16.1856 1.83334 14.457 1.83334 11.0001 1.83334C7.54312 1.83334 5.81464 1.83334 4.74069 2.90728C3.66675 3.98122 3.66675 5.70971 3.66675 9.16668V13.3322C3.66675 16.3068 3.66675 17.7941 4.47898 18.8015C4.64307 19.005 4.82845 19.1903 5.03197 19.3544C6.03937 20.1667 7.52667 20.1667 10.5012 20.1667C11.148 20.1667 11.4713 20.1667 11.7675 20.0622C11.8291 20.0405 11.8894 20.0154 11.9484 19.9873C12.2317 19.8517 12.4603 19.6231 12.9177 19.1658L17.2594 14.824C17.7894 14.2941 18.0543 14.0291 18.1939 13.6922C18.3334 13.3553 18.3334 12.9806 18.3334 12.2312Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsConditions);
export default __webpack_public_path__ + "static/media/terms-conditions.cdc94b367bd51a291c88a9ab82cf51fa.svg";
export { ForwardRef as ReactComponent };